import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '../../Services/ConfigService';

@Component({
	selector: 'PageHelp',
	templateUrl: 'PageHelp.html',
	moduleId: module.id
})
export class PageHelpComponent implements OnInit {

	ngOnInit() {
	}
	constructor(
		private configData: ConfigService,
		private router: Router) { }

	public get shouldShow(): boolean {
		return this.configData.isIntroVersion;
	}

	public _isMenuDescription: boolean = false;

	public get isMenuDescription() {
		return this._isMenuDescription;
	}
	@Input()
	public set isMenuDescription(bl: boolean) {
		this._isMenuDescription = bl;
	}

	public _menuKey : string = '';

	public get menuKey() : string {
		return this._menuKey;
	}
	@Input()
	public set menuKey(key: string) {
		this._menuKey = key;
		if (this.menuKey) {
			if (this.configData.MenuPages[this.menuKey]) {
				if (this.isMenuDescription) {
					if (this.configData.MenuPages[this.menuKey].MenuDescription) {
						this._content = this.configData.MenuPages[this.menuKey].MenuDescription;
					}
				} else {
					if (this.configData.MenuPages[this.menuKey].HelpLink) {
						this._content = this.configData.MenuPages[this.menuKey].HelpLink;
					}
				}
			}
		}
	}

	public _content: string = '';

	public get content(): string {
		return this._content;
	}

	
}
